export async function Agendamento(grupo, inicio, fim, on, off, tipo) {
    try {
      const response = await fetch('https://terrazza.cmd-automacao.com/agendar', {
        method: 'POST', // Especifica que a requisição é do tipo POST
        headers: {
          'Content-Type': 'application/json' // Define o tipo de conteúdo como JSON
        },
        body: JSON.stringify({ // Converte os dados para o formato JSON
          grupo: grupo,
          inicio: inicio,
          fim: fim,
          on: on,
          off: off,
          tipo: tipo
        })
      });
  
      const data = await response.json();
      console.log("Dados recebidos:", data);
    } catch (error) {
      console.error("Erro na requisição HTTP POST:", error);
    }
  }